import React, { useState } from 'react';
import ParticipantHeader from './ParticipantHeader';
import ParticipantFilter from './ParticipantFilter';
import ParticipantList from './ParticipantList';

const ParticipantPanel = ({
  onClose,
  filterValue,
  handleFilterChange,
  localUsername,
  userId,
  getAvatarColor,
  raisedHands,
  screenPresenters,
  onLocalUserClick
}) => {
  const [totalParticipants, setTotalParticipants] = useState(0);

  return (
    <div className="participants-panel">
      <ParticipantHeader totalParticipants={totalParticipants} onClose={onClose} />
      <ParticipantFilter 
        filterValue={filterValue}
        handleFilterChange={handleFilterChange}
      />
      <ParticipantList 
        localUsername={localUsername}
        userId={userId}
        getAvatarColor={getAvatarColor}
        raisedHands={raisedHands}
        screenPresenters={screenPresenters}
        filterValue={filterValue}
        onLocalUserClick={onLocalUserClick}
        setTotalParticipants={setTotalParticipants}
      />
    </div>
  );
};

export default ParticipantPanel;